var map = {
	"./activity.svg": "6ed4",
	"./add-circle.svg": "f787",
	"./add-fill.svg": "2c95",
	"./add.svg": "f882",
	"./airplay.svg": "f864",
	"./alert-circle.svg": "75c7",
	"./alert-octagon.svg": "e6b6",
	"./alert-triangle-fill.svg": "b649",
	"./alert-triangle.svg": "d923",
	"./align-center.svg": "b834",
	"./align-justify.svg": "5bee",
	"./align-left.svg": "fb24",
	"./align-right.svg": "1b18",
	"./anchor.svg": "8524",
	"./aperture.svg": "8560",
	"./archive-fill.svg": "233a",
	"./archive.svg": "16c6",
	"./arrow-down-circle.svg": "4494",
	"./arrow-down-fill.svg": "d542",
	"./arrow-down-left.svg": "9846",
	"./arrow-down-right.svg": "e2ad",
	"./arrow-down.svg": "ed41",
	"./arrow-left-circle.svg": "58a0",
	"./arrow-left-fill.svg": "92af",
	"./arrow-left.svg": "4049",
	"./arrow-long-right-fill.svg": "9f3d",
	"./arrow-long-right.svg": "6953",
	"./arrow-right-circle.svg": "8da9",
	"./arrow-right-fill.svg": "987b",
	"./arrow-right.svg": "3d7f",
	"./arrow-up-circle.svg": "88a7",
	"./arrow-up-fill.svg": "855c",
	"./arrow-up-left.svg": "c11b",
	"./arrow-up-right.svg": "55a0",
	"./arrow-up.svg": "2175",
	"./at-sign.svg": "4aa4",
	"./attach.svg": "6db9",
	"./award-fill.svg": "e37e",
	"./award.svg": "8572",
	"./bar-chart-2.svg": "c904",
	"./bar-chart.svg": "dece",
	"./battery-charging.svg": "a1d8",
	"./battery-fill.svg": "a5ff",
	"./battery.svg": "ac4a",
	"./bluetooth.svg": "7df5",
	"./bold.svg": "d2b1",
	"./book-open.svg": "ee39",
	"./book.svg": "0c13",
	"./bookmark.svg": "208b",
	"./box.svg": "a8bd",
	"./branch.svg": "c777",
	"./briefcase.svg": "eed7",
	"./business-card-fill.svg": "659c",
	"./business-card.svg": "47a4",
	"./calendar-fill.svg": "fcc0",
	"./calendar-x.svg": "28f1",
	"./calendar.svg": "dd54",
	"./camera-fill.svg": "d423",
	"./camera-off-fill.svg": "e154",
	"./camera-off.svg": "c940",
	"./camera.svg": "a97e",
	"./campaign-fill.svg": "ad92",
	"./campaign.svg": "79b8",
	"./cast.svg": "511e",
	"./chart-fill.svg": "d656",
	"./chart.svg": "5fd7",
	"./check-circle.svg": "2094a",
	"./check-square.svg": "4af3",
	"./check.svg": "3cad",
	"./checkmark.svg": "f89c",
	"./chevron-down-fill.svg": "a0cff",
	"./chevron-down.svg": "cafb",
	"./chevron-left-fill.svg": "5829",
	"./chevron-left.svg": "34b0",
	"./chevron-right-fill.svg": "8c0b",
	"./chevron-right.svg": "0d2f",
	"./chevron-up-fill.svg": "33f9",
	"./chevron-up.svg": "90b4",
	"./chevrons-down.svg": "77ff",
	"./chevrons-left.svg": "dc16",
	"./chevrons-right.svg": "04f6",
	"./chevrons-up.svg": "9d88",
	"./chrome.svg": "4358",
	"./circle-fill.svg": "f7a5",
	"./circle.svg": "3d45",
	"./click.svg": "de41",
	"./clipboard-fill.svg": "d9d9",
	"./clipboard.svg": "9ec9",
	"./clock-filled.svg": "61bb",
	"./clock.svg": "384d",
	"./cloud-drizzle.svg": "8d45",
	"./cloud-fill.svg": "c8ff",
	"./cloud-lightning.svg": "fc44",
	"./cloud-off-fill.svg": "9042",
	"./cloud-off.svg": "6387",
	"./cloud-rain.svg": "feeb",
	"./cloud-snow.svg": "8f5b",
	"./cloud.svg": "97fc",
	"./code.svg": "a141",
	"./codepen.svg": "5310",
	"./collapse-vertical.svg": "b550",
	"./collapse.svg": "acca",
	"./command.svg": "2504",
	"./communication-fill.svg": "afe6",
	"./communication.svg": "8551",
	"./company-fill.svg": "2c52",
	"./company.svg": "6b8d",
	"./compass.svg": "a1b7",
	"./contact-add-user-plus.svg": "c60a",
	"./contact-user.svg": "5b50",
	"./contacts-users.svg": "6641",
	"./conversation.svg": "66f4",
	"./copy.svg": "266e",
	"./corner-down-left.svg": "3dad",
	"./corner-down-right.svg": "be03",
	"./corner-left-down.svg": "86c1",
	"./corner-left-up.svg": "7da1",
	"./corner-right-down.svg": "24fd",
	"./corner-right-up.svg": "1a4e",
	"./corner-up-left.svg": "79ac",
	"./corner-up-right.svg": "3924",
	"./credit-card-fill.svg": "25ab",
	"./credit-card.svg": "8131",
	"./crop.svg": "1fa7",
	"./crosshair-fill.svg": "c898",
	"./crosshair.svg": "4d1e",
	"./cursor-click-fill.svg": "8b22",
	"./cursor-click.svg": "1ec5",
	"./database.svg": "fbd5",
	"./delete.svg": "52bf",
	"./disc.svg": "fdfa",
	"./dollar.svg": "152a",
	"./download-cloud.svg": "7ddb",
	"./download.svg": "9872",
	"./draggable.svg": "2682",
	"./droplet.svg": "3316",
	"./edit-2-fill.svg": "c491",
	"./edit-2.svg": "ea8f",
	"./edit.svg": "3b3b",
	"./email-fill.svg": "531b",
	"./email-open-fill.svg": "5212",
	"./email-open.svg": "98f6",
	"./email.svg": "3632",
	"./emoji-fill.svg": "93fa",
	"./emoji.svg": "85a8",
	"./euro.svg": "6afa",
	"./expand-vertical.svg": "5063",
	"./expand.svg": "ade7",
	"./external-link.svg": "5512",
	"./eye-hide.svg": "0e62",
	"./eye-show.svg": "5db6",
	"./eyedropper-fill.svg": "576e",
	"./eyedropper.svg": "bbf9",
	"./facebook-fill.svg": "778d",
	"./facebook.svg": "7909",
	"./fast-forward-fill.svg": "2758",
	"./fast-forward.svg": "bbfe",
	"./feather.svg": "52af",
	"./file-fill.svg": "1bf8",
	"./file-minus-fill.svg": "4fff1",
	"./file-minus.svg": "2680",
	"./file-plus-fill.svg": "53f7",
	"./file-plus.svg": "96e3",
	"./file.svg": "95b4",
	"./film.svg": "f31a",
	"./filter.svg": "fc30",
	"./fire-fill.svg": "8e61",
	"./fire.svg": "893d",
	"./flag-fill.svg": "76f1",
	"./flag.svg": "dd01",
	"./folder-fill.svg": "ef51",
	"./folder-minus-fill.svg": "8acf",
	"./folder-minus.svg": "ff78",
	"./folder-plus-fill.svg": "127f",
	"./folder-plus.svg": "51bd",
	"./folder.svg": "b523",
	"./font.svg": "fcba",
	"./form-fill.svg": "489f",
	"./form.svg": "dc84",
	"./funnel-fill.svg": "3a71",
	"./funnel.svg": "35b3",
	"./gift-fill.svg": "0853",
	"./gift.svg": "ed65",
	"./git-commit.svg": "acdc",
	"./git-pull-request.svg": "d7a7",
	"./github.svg": "0d17",
	"./gitlab.svg": "1f4f",
	"./globe.svg": "ce7f",
	"./grid.svg": "ce99",
	"./hamburger-fill.svg": "6fb0",
	"./hamburger.svg": "84c6",
	"./hard-drive.svg": "d7d7",
	"./hash.svg": "65fa",
	"./headphones-mic-fill.svg": "8434",
	"./headphones-mic.svg": "a8ce",
	"./headphones.svg": "e6b5",
	"./heart-fill.svg": "75a9",
	"./heart.svg": "ec61",
	"./help-circle-fill.svg": "559e",
	"./help-circle.svg": "f8c0",
	"./home-fill.svg": "25b7",
	"./home.svg": "b9a3",
	"./image.svg": "b266",
	"./inbox.svg": "ef9f",
	"./info-circle-fill.svg": "1d4b",
	"./info-circle.svg": "5248",
	"./instagram-fill.svg": "2588",
	"./instagram.svg": "6078",
	"./integrations-fill.svg": "5e64",
	"./integrations.svg": "fc8d",
	"./italic.svg": "f4a4",
	"./key-command.svg": "3176",
	"./key-delete-fill.svg": "d5a4",
	"./key-delete.svg": "6163",
	"./layers.svg": "40d6",
	"./layout.svg": "e866",
	"./life-buoy-fill.svg": "36b2",
	"./life-buoy.svg": "43bd",
	"./lightbulb-fill.svg": "841d",
	"./lightbulb.svg": "9499",
	"./lightning-fill.svg": "b2f9",
	"./link-horiz.svg": "59ff",
	"./link.svg": "d0bf",
	"./linkedin-fill.svg": "2485",
	"./linkedin.svg": "0c7d",
	"./list-cards.svg": "fab9",
	"./list-fill.svg": "0aa1",
	"./list-num.svg": "9afe",
	"./list-unordered.svg": "8975",
	"./list.svg": "12ef",
	"./loader.svg": "4b38",
	"./location-fill.svg": "e61e2",
	"./location.svg": "9f3e",
	"./lock-locked-fill.svg": "1b73",
	"./lock-locked.svg": "e929",
	"./lock-unlocked-fill.svg": "7088",
	"./lock-unlocked.svg": "8ced",
	"./lock.svg": "f0af",
	"./log-in.svg": "b3fa",
	"./log-out.svg": "8107",
	"./map.svg": "790f",
	"./maximize-2.svg": "50c4f",
	"./maximize.svg": "c943",
	"./megaphone-fill.svg": "2340",
	"./megaphone.svg": "4158",
	"./merge-field.svg": "35ad",
	"./merge.svg": "e81f",
	"./message-fill.svg": "187a",
	"./message-square-fill.svg": "5693",
	"./message-square.svg": "9531",
	"./message.svg": "1ed4",
	"./messages-automated.svg": "7e1b",
	"./mic-off.svg": "7bea",
	"./mic-on.svg": "b799",
	"./mic.svg": "05be",
	"./minimize-2.svg": "501a",
	"./minimize.svg": "ded2",
	"./minus-circle.svg": "0eee",
	"./minus-fill.svg": "6530",
	"./minus-square.svg": "3ca8",
	"./minus.svg": "f4b6",
	"./moon-fill.svg": "6d95",
	"./moon-stars-fill.svg": "e7fb",
	"./moon-stars.svg": "abc5",
	"./moon.svg": "ea6c",
	"./more-fill.svg": "5d48",
	"./more-horizontal-fill.svg": "d54c",
	"./more-horizontal.svg": "cd9c",
	"./more-vertical.svg": "9dd8",
	"./more.svg": "0e94",
	"./move.svg": "3429",
	"./music.svg": "37f1",
	"./navigation-2-fill.svg": "9a2d",
	"./navigation-2.svg": "7a89",
	"./navigation-fill.svg": "7334",
	"./navigation.svg": "ff69",
	"./note-fill.svg": "b052",
	"./note.svg": "2b3b",
	"./notes-fill.svg": "3398",
	"./notes.svg": "0716",
	"./notification-fill.svg": "b4df",
	"./notification-off-fill.svg": "0421",
	"./notification-off.svg": "c341",
	"./notification-zz.svg": "7964",
	"./notification.svg": "a51f",
	"./octagon-fill.svg": "0acb",
	"./octagon.svg": "c9fd",
	"./package.svg": "4c67",
	"./pause-circle-fill.svg": "8d53",
	"./pause-circle.svg": "4323",
	"./pause-fill.svg": "75ef",
	"./pause.svg": "1d74",
	"./pencil-edit-fill.svg": "0289",
	"./pencil-edit.svg": "d69f",
	"./pencil.svg": "54f8",
	"./percent-fill.svg": "4465",
	"./percent.svg": "ef74",
	"./phone-call-fill.svg": "03db",
	"./phone-call.svg": "7ead",
	"./phone-dialpad.svg": "c28d",
	"./phone-fill.svg": "b732",
	"./phone-forwarded-fill.svg": "3b15",
	"./phone-forwarded.svg": "c122",
	"./phone-incoming-fill.svg": "108f",
	"./phone-incoming.svg": "7729",
	"./phone-missed-fill.svg": "9937",
	"./phone-missed.svg": "98db",
	"./phone-off-fill.svg": "aba3",
	"./phone-off.svg": "2b9e",
	"./phone-outgoing-fill.svg": "5e98",
	"./phone-outgoing.svg": "a3a5",
	"./phone-rejected-fill.svg": "f30e",
	"./phone-rejected.svg": "c278",
	"./phone.svg": "80b2",
	"./pie-chart-fill.svg": "c0a8",
	"./pie-chart.svg": "4204",
	"./pin-fill.svg": "67bd",
	"./pin.svg": "0b5a",
	"./pipeline-fill.svg": "43c5",
	"./pipeline.svg": "1aa2",
	"./play-circle-fill.svg": "fc59",
	"./play-circle.svg": "3f59",
	"./play-fill.svg": "ee12",
	"./play.svg": "5043",
	"./playbook.svg": "9902",
	"./plus-square.svg": "b117",
	"./pocket.svg": "3b5a",
	"./pound.svg": "1e9e",
	"./power.svg": "6613",
	"./printer.svg": "a26b",
	"./profile-fill.svg": "896a",
	"./profile.svg": "e676",
	"./qr-code.svg": "9067",
	"./quote-euro.svg": "3b7e",
	"./quote-pound.svg": "8163",
	"./quote.svg": "7fa2",
	"./radio.svg": "bb9d",
	"./receipt-euro-filled.svg": "351d",
	"./receipt-euro.svg": "bd4a",
	"./receipt-filled.svg": "e43f",
	"./receipt-pound-filled.svg": "438e",
	"./receipt-pound.svg": "137a",
	"./receipt.svg": "f371",
	"./recurring-euro.svg": "eefa",
	"./recurring-pound.svg": "c440",
	"./recurring.svg": "a492",
	"./refresh-ccw.svg": "1ae3",
	"./refresh-cw-sync.svg": "4e83",
	"./refresh-cw.svg": "ae82",
	"./rename.svg": "df06",
	"./replace.svg": "a708",
	"./resize.svg": "d241",
	"./rewind.svg": "9328",
	"./rotate-ccw.svg": "f354",
	"./rotate-cw-redo.svg": "e639",
	"./rotate-cw.svg": "521c",
	"./rss.svg": "14d4",
	"./sales money-fill.svg": "df81",
	"./sales-euro-fill.svg": "efe6",
	"./sales-euro.svg": "7738",
	"./sales-fill.svg": "e0c4",
	"./sales-pound-fill.svg": "2cac",
	"./sales-pound.svg": "9109",
	"./sales.svg": "b6b3",
	"./save.svg": "9463",
	"./scissors.svg": "eac2",
	"./search-fill.svg": "09ae",
	"./search.svg": "d97c",
	"./send.svg": "369e",
	"./server.svg": "e45d",
	"./settings-fill.svg": "819c",
	"./settings.svg": "1e62",
	"./share-2.svg": "8874",
	"./share.svg": "f89b",
	"./shield-fill.svg": "46f9",
	"./shield-off.svg": "5a06",
	"./shield.svg": "2833",
	"./shopping-bag.svg": "417c",
	"./shopping-cart.svg": "708a",
	"./shuffle.svg": "e33f",
	"./sidebar-collapse.svg": "6800",
	"./sidebar-expand.svg": "3456",
	"./sidebar.svg": "ac4b",
	"./sign-in-log-in.svg": "1a0f",
	"./skip-back.svg": "b9e8",
	"./skip-forward.svg": "f7b9",
	"./slack.svg": "3878",
	"./slash.svg": "a016",
	"./sliders.svg": "82bb",
	"./sort.svg": "771f",
	"./speaker.svg": "f09e",
	"./square-fill.svg": "995d",
	"./square.svg": "12c7",
	"./star-fill.svg": "dbe1",
	"./star.svg": "edcf",
	"./stop-circle.svg": "5c31",
	"./strategy.svg": "59b0",
	"./strikethrough.svg": "7e66",
	"./sun-fill.svg": "fc8f",
	"./sun.svg": "db1e",
	"./sunrise.svg": "f8fa",
	"./sunset.svg": "aed2",
	"./switch-left-fill.svg": "8b21",
	"./switch-left.svg": "bfab",
	"./switch-right-fill.svg": "c23b",
	"./switch-right.svg": "9df8",
	"./tag-fill.svg": "a88e",
	"./tag.svg": "f604",
	"./target.svg": "fa3c",
	"./tasks-fill.svg": "ebc3",
	"./tasks.svg": "e73f",
	"./templates-fill.svg": "3c69",
	"./templates.svg": "cb50",
	"./terminal.svg": "f92b",
	"./thermometer-fill.svg": "acd5",
	"./thermometer.svg": "092d",
	"./thumbs-down.svg": "3516",
	"./thumbs-up.svg": "0544",
	"./toggle-left.svg": "6942",
	"./toggle-right.svg": "c459",
	"./trash-2-fill.svg": "f690",
	"./trash-2.svg": "1861",
	"./trash-fill.svg": "22f7",
	"./trash.svg": "41e2",
	"./trending-down.svg": "4f38",
	"./trending-up.svg": "3c27",
	"./triangle-fill.svg": "2757",
	"./triangle.svg": "35b6",
	"./truck.svg": "2b1a",
	"./tv.svg": "412f",
	"./twitter-fill.svg": "4c04",
	"./twitter.svg": "6830",
	"./type-off.svg": "c38b",
	"./type-size.svg": "8851",
	"./type.svg": "aeb4",
	"./umbrella-fill.svg": "4278",
	"./umbrella.svg": "870e",
	"./underline.svg": "c013",
	"./union.svg": "67e2",
	"./unlock.svg": "317a",
	"./upload-cloud.svg": "db16",
	"./upload.svg": "a806",
	"./user-check.svg": "ee1e",
	"./user-fill.svg": "4225",
	"./user-minus.svg": "abbb",
	"./user-plus.svg": "e40d",
	"./user-x.svg": "f059",
	"./user.svg": "e491",
	"./users-fill.svg": "9e84",
	"./users.svg": "c751",
	"./video-fill.svg": "3bac",
	"./video-off-fill.svg": "f4e3",
	"./video-off.svg": "0fd4",
	"./video.svg": "f9e1",
	"./view-desktop-fill.svg": "6c2c",
	"./view-desktop.svg": "e360",
	"./view-mobile.svg": "b208",
	"./view-tablet.svg": "05ca",
	"./voicemail-fill.svg": "76f2",
	"./voicemail.svg": "3b74",
	"./volume-1.svg": "abc0",
	"./volume-2.svg": "d031",
	"./volume-x.svg": "5394",
	"./volume.svg": "9489",
	"./watch-fill.svg": "25b7a",
	"./watch.svg": "dfdd",
	"./wifi-off.svg": "c700",
	"./wifi.svg": "b271",
	"./wind.svg": "9299",
	"./x-circle-fill.svg": "e207",
	"./x-circle.svg": "95ba",
	"./x-square-fill.svg": "17fc",
	"./x-square.svg": "0c6d",
	"./x.svg": "9ea5",
	"./youtube-fill.svg": "c7af",
	"./youtube.svg": "98c6",
	"./zap-fill.svg": "75c8",
	"./zap-off-fill.svg": "bac7",
	"./zap-off.svg": "62fe",
	"./zap.svg": "72f0",
	"./zoom-in.svg": "ea26",
	"./zoom-out.svg": "5b11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0169";